'use client';
import { FC, useCallback, useEffect, useState } from 'react';
import { Conditional } from 'components/pcc-components';
import EquipmentForm from '../equipment-form';
import { CatGrid, CatGridItem } from 'components/blocks-components';
import MyEquipmentView from './my-equipment-view';
import MyEquipmentGrid from './my-equipment-grid';
import { DeleteEquipmentDrawer } from 'components/my-equipment/delete-equipment-drawer/delete-equipment-drawer';
import { EquipmentResponse } from 'services/equipment/types';
import { EditEquipmentDrawerClient } from 'components/my-equipment/edit-equipment-drawer/edit-equipment-drawer-client';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { SelectedEquipmentInfo } from '../../../_header/components/equipment-widget/types';
import AddEquipmentHeading from '../add-equipment-heading';

export interface MyEquipmentProps {
  equipment: EquipmentResponse;
  isLoggedIn: boolean;
  partModificationFeatureFlag?: boolean;
}

const MyEquipment: FC<MyEquipmentProps> = ({
  equipment,
  isLoggedIn,
  partModificationFeatureFlag = false
}) => {
  const [editEquipment, setEditEquipment] =
    useState<null | SelectedEquipmentInfo>(null);
  const { editEquipmentDrawer } = useMyEquipmentDrawer();

  const { myEquipmentList = [], selectedEquipmentIndex: index = -1 } =
    equipment || {};
  if (index > 0) {
    // Place selected equipment at the begining.
    myEquipmentList.unshift(myEquipmentList.splice(index, 1)[0]);
    equipment['selectedEquipmentIndex'] = 0;
  }

  useEffect(() => {
    editEquipment && editEquipmentDrawer?.openDrawer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editEquipment]);

  const handleEditOpen = useCallback((equipment: Equipment) => {
    const { assetName = '', id = '' } = equipment || {};
    const obj = {
      ...(equipment ?? {}),
      assetId: assetName,
      productId: id
    } as SelectedEquipmentInfo;
    setEditEquipment(obj);
  }, []);

  return (
    <>
      <div className="w-100 cat-u-margin-top-xl cat-u-margin-bottom-xl">
        <Conditional
          test={(myEquipmentList ?? []).length <= 2}
          fallback={
            <MyEquipmentGrid
              equipment={equipment}
              handleEditOpen={handleEditOpen}
              partModificationFeatureFlag={partModificationFeatureFlag}
            />
          }
        >
          <Conditional
            test={!(myEquipmentList ?? []).length}
            fallback={
              <MyEquipmentView
                equipment={equipment}
                handleEditOpen={handleEditOpen}
                isLoggedIn={isLoggedIn}
                partModificationFeatureFlag={partModificationFeatureFlag}
              />
            }
          >
            <Conditional
              test={!partModificationFeatureFlag}
              fallback={<AddEquipmentHeading />}
            >
              <CatGrid variant="side-by-side" className="d-none d-lg-block">
                <CatGridItem>
                  <EquipmentForm isLoggedIn={isLoggedIn} />
                </CatGridItem>
              </CatGrid>
              <div className="d-lg-none">
                <EquipmentForm isLoggedIn={isLoggedIn} />
              </div>
            </Conditional>
          </Conditional>
        </Conditional>
      </div>
      <EditEquipmentDrawerClient
        isLoggedIn={isLoggedIn}
        selectedEquipmentInfo={editEquipment ?? {}}
      />
      <DeleteEquipmentDrawer selectedEquipmentInfo={editEquipment ?? {}} />
    </>
  );
};

export default MyEquipment;
